const deprecated = []

export default deprecated
